import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { ARCHIVE_PATHS, loadArchive } from "@/pages/archiveRoute";

const container = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML at build time; when that
// markup is present we hydrate, otherwise we render fresh.
function start() {
  if (container.hasChildNodes()) {
    hydrateRoot(container, tree);
  } else {
    createRoot(container).render(tree);
  }
}
// An archive page's bundle must be in memory before hydrating it (see
// pages/archiveRoute.jsx). Every other page starts straight away.
const here = window.location.pathname.replace(/\/$/, "");
if (ARCHIVE_PATHS.includes(here)) {
  loadArchive(here).then(start, start);
} else {
  start();
}

// react-snap serialises the live DOM, and adjacent text nodes ("{city} · {date}")
// come out as ONE text node. React then sees a text mismatch on hydration
// (error #418), throws the prerendered markup away and re-renders the whole
// page, which also re-creates the hero poster and pushes LCP back by seconds.
// React's own server renderer avoids this by putting an empty comment between
// adjacent text nodes, and hydration skips comments. Do the same here, only
// while react-snap is taking its snapshot (it waits 1500ms; see package.json).
if (navigator.userAgent === "ReactSnap") {
  setTimeout(() => {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    const split = [];
    while (walker.nextNode()) {
      const prev = walker.currentNode.previousSibling;
      if (prev && prev.nodeType === Node.TEXT_NODE) split.push(walker.currentNode);
    }
    for (const node of split) node.parentNode.insertBefore(document.createComment(" "), node);
  }, 1000);
}
